<template>
  <span v-if="legalTextParagraph?.valid_until">
    ({{ $t("legal_text.old_version_short", { validUntil }) }})
  </span>
</template>
<script lang="ts" setup>
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

const props = defineProps<{
  legalTextParagraph?: ILegalTextParagraph;
}>();

const validUntil = useDateFormat(
  () => props.legalTextParagraph?.valid_until ?? "",
  "DD.MM.YY"
);
</script>
